import { cn } from "@/lib/cn";
import type { StaticEntityType } from "@config";
import type { CSSProperties } from "react";
import { Wrapper, WrapperInner } from "../styles/Button.styled";
import "../styles/index.scss";
import type { ButtonProps, EditorDataProps, EditorSlotsProps } from "../types";
import { PRIMARY_PROPS, SECONDARY_PROPS } from "../utils";
import { Element } from "./Element";

export const ButtonLibrary = ({
  entity,
  editorSlots,
  editorData,
}: {
  entity: StaticEntityType;
  editorSlots?: EditorSlotsProps;
  editorData?: EditorDataProps;
}) => {
  const { settings, id } = entity as StaticEntityType<ButtonProps>;
  const width = editorData?.width || settings.width;
  const ButtonContent = editorSlots?.elementSlot || Element;

  return (
    <Wrapper
      $align={settings.horizontalAlignment}
      style={
        {
          "--entity-size": `${width ? `${width}%` : "auto"}`,
        } as CSSProperties
      }
      className={cn("tw-relative tw-flex", editorData?.className)}
    >
      {editorSlots?.resizeSlot}
      <WrapperInner
        ref={editorData?.elementRef}
        $direction={settings.direction}
        $showSecondaryButton={settings.showSecondaryButton}
        $containerSize={settings.containerSize}
        className={cn(
          "wrapper-rlYpKZsIh7LvvaB tw-relative tw-grid tw-gap-4 tw-overflow-hidden max-sm:!tw-w-full max-sm:!tw-grid-cols-1",
          {
            "max-md:tw-w-full": !width,
            "max-md:tw-w-[80%]": !!width && Number(width) < 80,
          },
        )}
      >
        <ButtonContent
          settings={PRIMARY_PROPS({ settings })}
          id={id}
          isSecondary={false}
        />
        {settings.showSecondaryButton === "two" && (
          <ButtonContent
            settings={SECONDARY_PROPS({ settings })}
            id={id}
            isSecondary
          />
        )}
      </WrapperInner>
    </Wrapper>
  );
};
